import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Link, Typography } from '@mui/material'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { checkIfProductionEnvironment } from 'src/lib/checkIfProductionEnvironment'
import SectionCard from '../components/SectionCard'
import { GuideGroup, TESTING_GUIDE } from './testingGuide'

const GuideGroupBlock = ({ group }: { group: GuideGroup }) => (
  <Box sx={{ mb: 2 }}>
    {group.heading && (
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        {group.heading}
      </Typography>
    )}
    <Box component={group.ordered ? 'ol' : 'ul'} sx={{ m: 0, pl: 2.5 }}>
      {group.items.map((item) => (
        <Typography key={item} component="li" variant="body2" sx={{ mb: 0.5 }}>
          {item}
        </Typography>
      ))}
    </Box>
    {group.link && (
      <Link href={group.link.href} target="_blank" rel="noreferrer" variant="body2">
        {group.link.label}
      </Link>
    )}
  </Box>
)

const AdvancedTestingGuide = () => {
  if (checkIfProductionEnvironment()) {
    return null
  }

  return (
    <SectionCard
      title="How to test"
      help="Testing guidance for development and staging, prepared with AI assistance."
      collapsible
    >
      <Box>
        {TESTING_GUIDE.map((section) => (
          <Accordion key={section.title} disableGutters variant="outlined">
            <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {section.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {section.groups.map((group, groupIndex) => (
                <GuideGroupBlock key={group.heading ?? groupIndex} group={group} />
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </SectionCard>
  )
}

export default AdvancedTestingGuide
